import { usersApi } from 'entities/users/model/usersApi';
import { SourceType } from 'entities/distribution/types';

const getSourcesApi = usersApi.injectEndpoints({
  endpoints: (builder) => ({
    getSources: builder.query<SourceType[], any>({
      query: () => '/account/admin/dicts/sources/',
    }),
  }),
});

export const { useGetSourcesQuery } = getSourcesApi;
